<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useFavoritesStore } from '@/stores/favorites';
import IconSports from '@/helpers/icon-pack-sports.vue';
import { getIconAlias } from '@/utils/transform';

export default defineComponent({
  name: 'competitions',
  components: { IconSports },
  computed: {
    ...mapState(useFavoritesStore, ['competitionsLoading']),
  },
  methods: {
    getIconAlias,
    ...mapActions(useFavoritesStore, ['addPopularCompetition']),
  },
  props: ['competitions', 'addSportFilter', 'addRegionFilter'],
});
</script>

<template>
  <section class="relative mx-3">
    <div v-if="competitionsLoading" class="table-loader">
      <i class="pi pi-spinner animate-spin text-gray-200" style="font-size: 5em" />
    </div>
    <table class="basic-table">
      <thead>
        <tr>
          <th style="min-width: 80px; width: 80px">ID</th>
          <th style="width: 100px; text-align: left">Спорт</th>
          <th style="text-align: left">Турнир</th>
          <th style="width: 200px">Регион</th>
          <th style="width: 80px">Матчей</th>
          <th style="width: 80px">Действия</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="competition in competitions" :key="competition.Id">
          <tr>
            <td>{{ competition.Id }}</td>
            <td>
              <div class="flex gap-1 flex-wrap">
                <IconSports
                  v-for="id in competition.SportIds"
                  v-key="id"
                  @click="addSportFilter(id)"
                  cssClass="fill-gray-600 dark:fill-white cursor-pointer"
                  :id="getIconAlias(id)"
                  :height="20"
                  :width="20"
                />
              </div>
            </td>
            <td style="text-align: left">{{ competition.Name }}</td>
            <td class="cursor-pointer" @click="addRegionFilter(competition.Region.Id)">
              {{ competition.Region?.Name }}
            </td>
            <td>{{ competition._count.Fixtures }}</td>
            <td>
              <div
                class="cursor-pointer"
                title="Удалить"
                @click="addPopularCompetition(competition.Id)"
              >
                <i class="pi pi-plus text-green-500"></i>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </section>
</template>
